// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"218":"5c3bcbd7b143497f","3426":"c7ce8fe55e1cafe3","3784":"3d072e8bd976ef28","9105":"7aecee6361035ad1"}[chunkId] + ".css";
};